import React, { useMemo } from 'react';
import { CoveoHeadless } from '@arm/ce-shared-components';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import config from '../../../temp/config';
import StarsRating from '../../SharedComponents/StarsRating';
import FeatureAnnouncementPanel from '../../SharedComponents/FeatureAnnouncementPanel';
import RenderingStyling from '../../../lib/RenderingStyling';
import { UseGlobalState } from '../../../context';
import { getAuthCoveoUser } from '../../../utils/authAccessToken';
import './SecurityCenter.css';

// Keep the search configuration stable across user-context updates.
const SECURITY_CENTER_FACETS = [
  {
    title: 'Product Type',
    field: 'navigationhierarchiesprocessortype',
    isHierarchial: false,
    showCountsInFacet: false,
    enableFacetSearch: true,
  },
  {
    title: 'Document Type',
    field: 'navigationhierarchiescontenttype',
    isHierarchial: false,
    showCountsInFacet: false,
    enableFacetSearch: true,
  },
];

const SecurityCenterContainer = ({ rendering, sitecoreContext }) => {
  const { user } = UseGlobalState();

  // Access titles from rendering fields
  const header1Text = rendering?.fields?.Header1Title?.value || '';
  const header2Text = rendering?.fields?.Header2Title?.value || '';
  const header3Text = rendering?.fields?.Header3Title?.value || '';

  // A new options object reapplies the default sort and resets the Coveo page.
  const tableOptions = useMemo(
    () => ({
      defaultSort: { field: 'published', order: 'desc' },
      itemsPerPage: 20,
      header1: header1Text,
      header2: header2Text,
      header3: header3Text,
    }),
    [header1Text, header2Text, header3Text]
  );

  return (
    <div className="security-center-container" {...RenderingStyling(rendering.componentName)}>
      <CoveoHeadless
        CoveoOrganizationID={`${config.REACT_APP_COVEOORGANIZATIONID}`}
        CoveoGetTokenURI={`${config.REACT_APP_COVEOGETSEARCHTOKENURL}`}
        CoveoSearchHub={`${config.REACT_APP_SECURITYCENTERSEARCHHUB}`}
        CoveoQueryPipeline={`${config.REACT_APP_SECURITYCENTERQUERYPIPELINE}`}
        tabId={`${config.REACT_APP_COVEORESOURCESTABID}`}
        user={getAuthCoveoUser(user)}
        switchTagsLocation={true}
        showCountsInFacet={false}
        resultViewType="table"
        showRecommendedTag={true}
        showSmartSnippet={true}
        showAdvancedSearch={false}
        facetsConfig={SECURITY_CENTER_FACETS}
        useUrlParams={true}
        tabDocumentSourceName={config.REACT_APP_COVEO_DOCUMENT_SOURCE}
        tabCommunitySourceName={config.REACT_APP_COVEO_COMMUNITY_SOURCE}
        tableOptions={tableOptions}
        searchBoxTextPlaceholder={
          rendering?.fields?.SearchBoxTextPlaceholder?.value || 'Search security advisories'
        }
      >
        <StarsRating uid={rendering.uid} />
        <FeatureAnnouncementPanel fields={rendering?.fields} />
      </CoveoHeadless>
    </div>
  );
};

export default withSitecoreContext()(SecurityCenterContainer);
